module.exports = __webpack_public_path__ + "img/picture-grayscale-min.efb6991f.jpeg";